import mainLogo from '../../images/Barigui/barigui_logo_main_color.png';
import squareLogo from '../../images/Barigui/barigui_logo_square_color.png';
import mainLogoWhite from '../../images/Barigui/barigui_logo_main_white.png';
import squareLogoWhite from '../../images/Barigui/barigui_logo_square_white.png';
import banner01 from '../../images/Barigui/barigui_banner_02.jpg';
import banner02 from '../../images/Barigui/barigui_banner_01.jpg';
import banner03 from '../../images/Barigui/barigui_banner_03.jpg';
import banner04 from '../../images/Barigui/barigui_banner_04.jpg';
import bannerStudio from '../../images/Barigui/banner_studio.jpg';
import car123 from '../../images/Barigui/123_toro.jpg';
import box123 from '../../images/Barigui/123_barigui.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

import bannerBydDesk from '../../images/Barigui/barigui_banner_byd_02_desk.jpg';
import bannerBydMobile from '../../images/Barigui/barigui_banner_byd_02_mobile.jpg';

import bannerFordDesk from '../../images/Barigui/barigui_banner_ford_desk.jpg';
import bannerFordMobile from '../../images/Barigui/barigui_banner_ford_mobile.jpg';

import bannerFiatDesk from '../../images/Barigui/barigui_banner_fiat_desk.jpg';
import bannerFiatMobile from '../../images/Barigui/barigui_banner_fiat_mobile.jpg';

import bannerBmwDesk from '../../images/Barigui/barigui_banner_bmw_desk.jpg';
import bannerBmwMobile from '../../images/Barigui/barigui_banner_bmw_mobile.jpg';

import bannerRenaultDesk from '../../images/Barigui/barigui_banner_renault_desk.jpg';
import bannerRenaultMobile from '../../images/Barigui/barigui_banner_renault_mobile.jpg';

import bannerCheryDesk from '../../images/Barigui/barigui_banner_chery_desk.jpg';
import bannerCheryMobile from '../../images/Barigui/barigui_banner_chery_mobile.jpg';

import bannerNissanDesk from '../../images/Barigui/barigui_banner_nissan_desk.jpg';
import bannerNissanMobile from '../../images/Barigui/barigui_banner_nissan_mobile.jpg';

import bannerVwDesk from '../../images/Barigui/barigui_banner_vw_desk.jpg';
import bannerVwMobile from '../../images/Barigui/barigui_banner_vw_mobile.jpg';

import bannerImgKits_desk from '../../images/Barigui/barigui_banner_Kits_01.webp';
import bannerImgKits_mobile from '../../images/Barigui/barigui_banner_Kits_02_mobile.webp';

import acessImg from '../../images/acessImg2.webp';
import { clothingItems } from '../../Utilities/clothingItems';

export const configData = {
    defaultStore: 'Barigui',
    defaultStoreLink: 'pecas.grupobarigui.com.br',
    defaultContactEmail: 'ecommerce@grupobarigui.com.br',
    whatsappNumber: '41 3017 7513',
    CNPJ: '08.540.795/0001-32',
    CNPJname: 'Felicio Barigui & Filhos LTDA',
    CNPJaddress: 'Rod. BR 101 - KM 206, 590 - Sala 01 - Nossa Senhora do Rosario, São José/SC - 88.110-600',
    launchDate: '01/07/2025',

    multiContact: {
        'Fiat Barigui PR (41 3017 7513)': '41 3017 7513',
        'Fiat Barigui SC (47 3035 9148)': '47 3035 9148',
        // 'BYD Barigui (41 3012 4052)': '41 3012 4052',
        'Renault Barigui  (41 3017 7490)': '41 3017 7490',
        'Nissan Barigui PR (41 3021 4246)': '41 3021 4246',
        'Volkswagen Matriz (48 3094 4080)': '48 3094 4080',
        // 'Atendimento Geral': '41 3017 7513',


        // 'Fiat Barigui Torres PR': '41 3017 7513',
        // // 'Fiat Barigui Blumenau SC': '47 3035 9148',

        // 'BYD Tarumã PR': '41 3012 4052',

        // // 'Renault Parque PR (Alexandro )': '41 3017 7206',
        // // 'Renualt Maringá PR (Jackson)': '44 3032 5746',
        // // 'Renault Londrina PR (Maicon)': '43 3031 2960',
        // // 'Renualt Guarapuava PR (Vanderlei)': '42 3303 1608',
        // // 'Renault Paranaguá PR (Victor)': '41 3038-9510',
        // // 'Renault Ponta Grossa PR (Michele)': '42 3219 5112',
        // 'Renualt Marechal PR (Matheus)': '41 3017 7490',
        // // 'Renault Telepeças': '41 3021 8981',

        // // 'Nissan Guarapuava PR (Alan)': '42 3621 6929',
        // // 'Nissan Ponta Grossa PR (Michele)': '42 3219 5112',
        // 'Nissan Marechal': '41 3021 4246',

        // 'Volkswagen Matriz PR': '48 3094 4080',
        // // 'Volkswagen Cabral PR': '41 3313 3015',
        // // 'Volkswagen Blusa': '47 3331 0129',
    },
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        // 'audi',
        // 'bmw',
        // 'byd',
        'chery',
        // 'citroen',
        'fiat',
        // 'ford',
        // 'hyundai',
        // 'jeep',
        // 'kia',
        'nissan',
        // 'peugeot',
        'renault',
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Fórmula Curitiba - Parolin",
        "BARIGUI NISSAN",
        "BARIGUI CABRAL VW",
        "BARIGUI TORRES UBERADA",
        "BARIGUI CAOA CHERY - SAO JOSE DOS PINHAIS",
        "BARIGUI FIAT BLUMENAU",
        "BARIGUI VW - SAO JOSE (MATRIZ)",
        "BARIGUI CAOA CHERY - BLUMENAU",
    ],
    
    disabledSellers: [
        "BARIGUI AUDI - LONDRINA",
        "BARIGUI BYD - TARUMA",
        "BARIGUI PEUGEOT XV",
        "BARIGUI CITROEN PARQUE",
        "Barigui FORD Estoques",
        "BARIGUI BLUSA VW",
        "Fórmula Londrina",
        "BARIGUI BMW MARINGÁ",
        "BARIGUI KIA CAMPINA SIQUEIRA",
        "BARIGUI JEEP - TORRES",
        "Barigui FORD Maringá",
        "BARIGUI HYUNDAI SC",
        "NIX NISSAN BLUMENAU",
        "NIX NISSAN JOINVILLE",
        "BARI PONTA GROSSA HYUNDAI",
        // "BARIGUI CAOA CHERY - BLUMENAU",
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 4,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            1000: 4,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.KitsDiscountValue
        },
        {
            name: 'Kits Óleos',
            img: 'tabOleos',
            products: SliderProducts.KitsOilDiscountValue
        },
        {
            name: 'Kits Correias',
            img: 'tabCorreias',
            products: SliderProducts.KitsChainDiscountValue
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.FiltrosDiscountValue
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.AccessoriesDiscountValue
        },
        {
            name: 'Vestuário',
            img: 'tabRoupas',
            products: clothingItems
        },
        // {
        //     name: '',
        //     img: 'tabAudi',
        //     products: SliderProducts.BariguiAudi
        // },
        // {
        //     name: '',
        //     img: 'tabBMW',
        //     products: SliderProducts.BariguiBMWMINI
        // },
        // {
        //     name: '',
        //     img: 'tabBYD',
        //     products: SliderProducts.BariguiBYD
        // },
        // {
        //     name: '',
        //     img: 'tabChery',
        //     products: SliderProducts.BariguiChery
        // },
        // {
        //     name: '',
        //     img: 'tabCitroen',
        //     products: SliderProducts.BariguiCitroen
        // },
        // {
        //     name: '',
        //     img: 'tabFiat',
        //     products: SliderProducts.BariguiFiat
        // },
        // {
        //     name: '',
        //     img: 'tabFord',
        //     products: SliderProducts.BariguiFord
        // },
        // {
        //     name: '',
        //     img: 'tabHyundai',
        //     products: SliderProducts.BariguiHyundai
        // },
        // {
        //     name: '',
        //     img: 'tabJeep',
        //     products: SliderProducts.BariguiJeep
        // },
        // {
        //     name: '',
        //     img: 'tabKia',
        //     products: SliderProducts.BariguiKia
        // },
        // {
        //     name: '',
        //     img: 'tabNissan',
        //     products: SliderProducts.BariguiNissan
        // },
        // {
        //     name: '',
        //     img: 'tabPeugeot',
        //     products: SliderProducts.BariguiPeugeot
        // },
        // {
        //     name: '',
        //     img: 'tabRenault',
        //     products: SliderProducts.BariguiRenault
        // },
        // {
        //     name: '',
        //     img: 'tabVW',
        //     products: SliderProducts.BariguiVW
        // },

        // {
        //     name: 'Óleos',
        //     img: 'tabOleos',
        //     products: SliderProducts.Oleos
        // },
        // {
        //     name: 'Filtros',
        //     img: 'tabFiltros',
        //     products: SliderProducts.Filtros
        // },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        // {
        //     name: 'Freios',
        //     img: 'tabFreios',
        //     products: SliderProducts.Freios
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogoWhite,
    squareLogo: squareLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    aboutUsBg: banner03,
    bannerStudio: bannerStudio,
    bannerImg01: squareLogoWhite,

    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerImgKits_desk: bannerImgKits_desk,
    bannerImgKits_mobile: bannerImgKits_mobile,

    acessImg: acessImg,

    bannerBydDesk: bannerBydDesk,
    bannerBydMobile: bannerBydMobile,
    bannerFordDesk: bannerFordDesk,
    bannerFordMobile: bannerFordMobile,
    bannerFiatDesk: bannerFiatDesk,
    bannerFiatMobile: bannerFiatMobile,
    bannerBmwDesk: bannerBmwDesk,
    bannerBmwMobile: bannerBmwMobile,
    bannerRenaultDesk: bannerRenaultDesk,
    bannerRenaultMobile: bannerRenaultMobile,
    bannerCheryDesk: bannerCheryDesk,
    bannerCheryMobile: bannerCheryMobile,
    bannerNissanDesk: bannerNissanDesk,
    bannerNissanMobile: bannerNissanMobile,
    bannerVwDesk: bannerVwDesk,
    bannerVwMobile: bannerVwMobile,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias do <mark>Grupo Barigüi</mark>.',

    aboutUs: {
        title: 'Conheça o Grupo Barigüi',
        content: [
            'Por acreditar no futuro, nas pessoas e no país, o Grupo Barigüi é hoje o maior revendedor de automóveis e caminhões do Sul do Brasil. Ao longo da nossa trajetória, vendemos mais de 1 milhão de veículos das marcas Audi, BMW, BRP, BYD, Caoa Chery, Citroën, DAF, Fiat, Ford, Hyundai, Jeep, Kia, Lexus, Mini, Motorrad, Nissan, Peugeot, Renault, Toyota, Volkswagen.',
            'Mas nós não limitamos as nossas operações à comercialização de veículos e produtos ligados ao setor. A nossa vocação empresarial também pode ser expressa em outro propósito: o de transformar a vida das pessoas. Por isso, o Grupo Barigüi criou o Instituto Barigüi que, há mais de 17 anos, desenvolve programas gratuitos de educação profissional para jovens e pessoas com deficiência. E também investe em processos de gestão ambiental, oferecendo treinamento para que todos os nossos colaboradores façam a correta separação e reciclagem dos resíduos gerados em nossas concessionárias.',
            'Não paramos de pensar no futuro. Criamos o Banco Bari, um banco digital que nasce com o propósito de mudar a relação que o brasileiro tem com seu dinheiro, com soluções completas de conta, crédito e investimentos.',
            'Esse é o jeito de ser do Grupo Barigüi: investimos no Brasil, acreditamos nas pessoas e promovemos um modelo de negócios sustentável e inovador. É assim que reafirmamos o quanto acreditamos no futuro. Afinal, é para lá que estamos indo.',
        ],
        link: 'https://www.grupobarigui.com.br/institucional/sobre-nos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupobarigui/',
        Facebook: 'https://www.facebook.com/GrupoBariguiOficial',
        LinkedIn: 'https://www.linkedin.com/company/grupo-barigui/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}